import _ from "lodash";
import moment from "moment";
import { DropdownItemProps } from "semantic-ui-react";
const development: boolean =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development";

export default function isDev(): boolean {
  return development;
}

export function toDropdownOptions<T>(
  data: Set<T>,
  includeAll = false
): DropdownItemProps[] {
  const result: DropdownItemProps[] = [];

  includeAll && result.push({ text: "All" });

  data.forEach((v) => {
    result.push({ text: v, value: v as any, key: v });
  });

  return result;
}

export function fieldError(
  name: string,
  errors: any,
  pointing?: "left" | "right" | "below" | "top"
) {
  if (!errors) {
    return null;
  }

  const error = _.get(errors, name);
  if (error) {
    if (pointing) {
      return {
        content: error,
        pointing,
      };
    }
    return error;
  }

  return null;
}

export function formatDateTime(v?: string | Date, showSecond = false) {
  if (v) {
    const d = v instanceof Date ? v : new Date(v);
    if (showSecond) {
      return moment(d).format("YYYY-MM-DD HH:mm:ss");
    } else {
      return moment(d).format("YYYY-MM-DD HH:mm");
    }
  }

  return "";
}

export function parseDateTime(v?: string, showSecond = false) {
  if (v) {
    if (showSecond) {
      return moment(v, "YYYY-MM-DD HH:mm:ss").toDate();
    } else {
      return moment(v, "YYYY-MM-DD HH:mm").toDate();
    }
  }

  return undefined;
}

export function formatDate(v?: string) {
  if (v) {
    const d = new Date(v);
    return moment(d).format("YYYY-MM-DD");
  }

  return "";
}

export function untilStable<T>(
  valueObserer: () => T,
  done: (value: T) => void,
  interval = 200
) {
  let timeout: number;
  let isStop = false;
  const doIt = (lastVal?: T) => {
    if (isStop) {
      return;
    }
    const val = valueObserer();
    if (val === lastVal) {
      done(val);
    } else {
      timeout = setTimeout(doIt, interval, val);
    }
  };

  doIt(undefined);

  return () => {
    clearTimeout(timeout);
    isStop = true;
  };
}

export function toUrlQueryString(obj: any) {
  return window.btoa(encodeURIComponent(JSON.stringify(obj)));
}

export function downloadCSV(content: string, fileName: string) {
  const blob = new Blob(["\ufeff" + content], {
    type: "text/csv,charset=UTF-8",
  });
  openDownloadDialog(blob, fileName);
}

export function downloadTXT(content: string, fileName: string) {
  const blob = new Blob(["\ufeff" + content], {
    type: "text/txt,charset=UTF-8",
  });
  openDownloadDialog(blob, fileName);
}

export function openDownloadDialog(url: any, fileName: string) {
  if (typeof url === "object" && url instanceof Blob) {
    url = URL.createObjectURL(url);
  }
  const aLink = document.createElement("a");
  aLink.href = url;
  aLink.download = fileName;
  aLink.click();
}

export function parseQueryObject() {
  const queryParameters = decodeURIComponent(
    window.location.search.substring(1)
  );
  const result: any = {};
  for (const p of queryParameters.split("&")) {
    if (p) {
      const [k, v] = p.split("=");
      if (k) {
        result[k] = v;
      }
    }
  }

  return result;
}

function deviceType() {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return "tablet";
  } else if (
    /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua
    )
  ) {
    return "mobile";
  }
  return "desktop";
}

function isPhone() {
  return deviceType() == "mobile";
}

export function decodeHTMLEntities(text: string) {
  const textArea = document.createElement("textarea");
  textArea.innerHTML = text;
  return textArea.value;
}

export function encodeHTMLEntities(text: string) {
  const textArea = document.createElement("textarea");
  textArea.innerText = text;
  return textArea.innerHTML;
}


export function isContentEmpty(val: any) {
  return _.isNil(val) || val === '';
}


export function compareMeasurementName(a: string, b: string, desc = false) {
  let g = 1;
  let l = -1;
  if (desc) {
    g = -1;
    l = 1;
  }

  const aNum = a.trim().match(/^([0-9.]+)\. ?.+/);
  const bNum = b.trim().match(/^([0-9.]+)\. ?.+/);
  if (aNum && aNum[1] && bNum && bNum[1]) {
    const an = parseFloat(aNum[1]);
    const bn = parseFloat(bNum[1]);
    if (an != bn) {
      return an > bn ? g : l;
    }
  } else if (aNum || bNum) {
    return aNum ? l : g;
  }

  return a.trim() > b.trim() ? g : l;
}


export function generateParametersKey(data: any) {
  const keys = Object.keys(data).sort();

  return keys.map(k => `${k}=${JSON.stringify(data[k])}`).join(',')
}